module.exports = __webpack_public_path__ + "img/main.bb2143d1.png";